import { useMutation } from "@shared/lib/hooks";
import { DeliverableConfiguratorService } from "../services/deliverable.configurator.service";
import { IDeliverableConfigurator } from "@shared/lib/types";
import { DELIVERABLE_CONFIGURATOR_QUERY_KEY } from "../constants";

export default function useCreateDeliverableConfig() {
  const {
    mutate: createDeliverableConfig,
    isLoading: isCreateDeliverableConfigLoading,
    isSuccess: isCreateDeliverableConfigSuccess,
    error: createDeliverableConfigError,
  } = useMutation({
    mutationFn: (data: IDeliverableConfigurator) =>
      DeliverableConfiguratorService.createDeliverableConfig(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...DELIVERABLE_CONFIGURATOR_QUERY_KEY],
      });
    },
  });

  return {
    createDeliverableConfig,
    isCreateDeliverableConfigLoading,
    isCreateDeliverableConfigSuccess,
    createDeliverableConfigError,
  };
}
